module.exports = __webpack_public_path__ + "assets/img/chatworkLOGO.7d876a8c.png";